export default __webpack_public_path__ + "static/media/le_touquet5.7e53a1b5.jpg";